import {ThemeColorName, ThemeSpacingName} from '../../theme/types';
import {BaseLayoutProps} from '../layout';
import {ThemePaddingPxProps} from '../types';
import {InputIconSize, InputSize, InputState} from './types';

type InputLayoutMapType = {
  [key in InputSize]: {
    container: {
      height: number;
      padding: Pick<ThemePaddingPxProps, 'paddingHorizontal'>;
    };
    enhanced: {
      input: {
        padding: ThemeSpacingName;
      };
      textContainer: Pick<BaseLayoutProps, 'minWidth'>;
    };
  };
};

export const InputLayoutMap: InputLayoutMapType = {
  Small: {
    container: {
      height: 32,
      padding: {paddingHorizontal: '8'},
    },
    enhanced: {
      input: {
        padding: '6',
      },
      textContainer: {
        minWidth: undefined, // 24,
      },
    },
  },
  Default: {
    container: {
      height: 44,
      padding: {paddingHorizontal: '14'},
    },
    enhanced: {
      input: {
        padding: '10',
      },
      textContainer: {
        minWidth: undefined, // 24,
      },
    },
  },
  Large: {
    container: {
      height: 56,
      padding: {paddingHorizontal: '18'},
    },
    enhanced: {
      input: {
        padding: '10',
      },
      textContainer: {
        minWidth: undefined, // 24,
      },
    },
  },
};

type IconLayoutMapType = {
  [key in InputIconSize]?: {
    inside?: ThemeSpacingName;
    outside?: ThemeSpacingName;
  };
};

export const IconLayoutMap: IconLayoutMapType = {
  '16': {
    inside: '4',
    outside: '4',
  },
};

type InputStyleMapType = {
  [key in InputState]: {
    textColor: ThemeColorName;
    enhancerColor: ThemeColorName;
    placeholderColor: ThemeColorName;
    selectionColor: ThemeColorName;
    selectionBackgroundColor: ThemeColorName;
    backgroundColor: ThemeColorName;
    borderFocusColor: ThemeColorName | undefined;
    iconReversed: boolean;
  };
};

export const InputStyleMap: InputStyleMapType = {
  Default: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_mono_tertiary',
    borderFocusColor: 'border_accent_default',
    iconReversed: true,
  },
  Success: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_positive_light',
    borderFocusColor: 'border_positive_default',
    iconReversed: true,
  },
  Error: {
    textColor: 'content_mono_secondary',
    placeholderColor: 'content_mono_secondary',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_primary',
    backgroundColor: 'background_negative_light',
    borderFocusColor: 'border_negative_default',
    iconReversed: true,
  },
  Disabled: {
    textColor: 'content_mono_disabled',
    placeholderColor: 'content_mono_disabled',
    selectionColor: 'content_mono_inverse_primary',
    selectionBackgroundColor: 'background_accent_default',
    enhancerColor: 'content_mono_disabled',
    backgroundColor: 'background_mono_tertiary',
    borderFocusColor: 'transparent',
    iconReversed: true,
  },
};
